import axios from "axios";
import * as ROUTES from "../../constants/route";

export default class SignUpFunction {
  doAddUserData = (user, idToken) =>
    axios.post(
      `${ROUTES.FUNCTION_BASE_URL}clients-client/createNewUser`,
      JSON.stringify(user),
      {
        headers: buildJsonHeaders(idToken),
      }
    );

  doCheckUser = (email, idToken) =>
    axios.post(
      `${ROUTES.FUNCTION_BASE_URL}clients-client/checkNewUser`,
      email,
      {
        headers: buildJsonHeaders(idToken),
      }
    );
}

function buildJsonHeaders(idToken) {
  const headers = { "Content-Type": "application/json" };
  if (idToken) headers.Authorization = `Bearer ${idToken}`;
  return headers;
}
